const ecpRoutes = [
  {
    path: "/ecp",
    name: "",
    meta: {
      title: "비교과",
      isDynamic: true,
    },
    children: [
      /** 비교과 신청 */
      {
        path: "reg", // /ecp/reg
        name: "ecpRegIndex",
        meta: {
          title: "비교과 등록",
          titleEn: "Extracurricular Activities Registration",
          menuCd: "STAFF_ECP_REG",
        },
        component: () => import("@/views/staff/ecp/reg/EcpRegIndex.vue"),
      },
      {
        path: "reg/detail", // /ecp/reg/detail
        name: "ecpRegDetail",
        meta: {
          title: "비교과 등록 상세",
          titleEn: "Extracurricular Activities Registration Detail",
          menuCd: "STAFF_ECP_REG",
        },
        component: () => import("@/views/staff/ecp/reg/EcpRegDetail.vue"),
      },
      /** 비교과 운영 */
      {
        path: "oper", // /ecp/oper
        name: "ecpOperIndex",
        meta: {
          title: "비교과 운영",
          menuCd: "STAFF_ECP_OPER",
        },
        component: () => import("@/views/staff/ecp/oper/EcpOperIndex.vue"),
      },
      {
        path: "setting", // /ecp/oper/setting
        name: "ecpSetting",
        meta: {
          title: "비교과 설정",
          titleEn: "Extracurricular Activities Setting",
          menuCd: "STAFF_ECP_OPER",
        },
        component: () => import("@/views/staff/ecp/oper/EcpSetting.vue"),
      },
      /** 평생교육 */
      {
        path: "lifelong-edu", // /ecp/lifelong-edu
        name: "lifelongEduStaffIndex",
        meta: {
          title: "평생교육",
          titleEn: "Lifelong Education",
          menuCd: "STAFF_LIFELONG",
          isDynamic: true,
        },
        component: () => import("@/views/staff/ecp/lifelong-edu/LifelongEduStaffIndex.vue"),
      },
    ],
  },
];
export default ecpRoutes;
